import { useEffect, useState } from "react";
import { BiSearch, BiX } from "react-icons/bi";
import { Link, useHistory } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import "./navbar.css";
import { runningSubscription } from "./../actions/subscription";

const NavbarSection = ({
  setType,
  isCardView,
  onNavSearch,
  type,
  setSearch1,
  search1,
  propertVal,
  openNav1,
  setOpenNav1,
  auth,
  runningSubscription,
  setPage,
  setRoom,
  ...props
}) => {
  const { frontLabelsName } = props.label;
  const subscriptions = useSelector((state) => state.subscription);
  const subscription_details = subscriptions?.runningSubscription?.message;

  const isAuth = useSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (isAuth.isAuthenticated) {
      const userId = localStorage.getItem("user");
      runningSubscription(userId);
    }
  }, []);

  const [openNav, setOpenNav] = useState(openNav1);
  const [search2, setSearch2] = useState("");
  const history = useHistory();

  const handleNavSearch = (e) => {
    setOpenNav(!openNav);
  };

  const onClickSearch = () => {
    if (onNavSearch) {
      onNavSearch(search2);
    }
  };
  // useEffect(() => {
  //   search1 !== "" ? setOpenNav(true) : setOpenNav(false);
  // }, []);

  const onCloseSearch = async () => {
    setSearch2("");
    // setSearch1('');
    setOpenNav(!openNav);
    await onNavSearch("");
    history.push({ pathname: `/properties` });
    //  setOpenNav(!openNav);
  };
  const handleSearch = async (event) => {
    const newString = event?.target.value;
    // setSearch1(newString);
    setSearch2(newString);
  };
  const onFieldKeyPress = (e) => {
    if (e.key === "Enter") {
      if (isAuth == false) {
        history.push("/sample-properties");
      } else if (subscription_details == "Your subscription is expired.") {
        history.push("/sample-properties");
      } else {
        if (propertVal) {
          onNavSearch(e.target.value);
        } else {
          history.push({
            pathname: `/properties/?search=${search2}`,
            state: e.target.value,
          });
        }
      }
      // }
    }
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark1">
        <div className="container-fluid customize-navbar p-0">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo01"
            aria-controls="navbarTogglerDemo01"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-li d-flex align-items-center">
                {!openNav ? (
                  <div className="active quick" onClick={handleNavSearch}>
                    <BiSearch
                      className="nav-search-icon"
                      style={{ color: "#fff !important" }}
                    />

                    <span>
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_quick_search")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_quick_search"
                            )[0]["value"] || "lbl_quick_search"
                          : "lbl_quick_search"
                        : "lbl_quick_search"}
                    </span>
                  </div>
                ) : (
                  <div className="quick-search1">
                    <span className="d-flex align-items-center">
                      <input
                        type="text"
                        placeholder={
                          frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_quick_search"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_quick_search"
                                )[0]["value"] || "lbl_quick_search"
                              : "lbl_quick_search"
                            : "lbl_quick_search"
                        }
                        name="search"
                        autoFocus
                        value={search2}
                        // onChange={(e) => setSearch(e.target.value)}
                        onKeyPress={(e) => onFieldKeyPress(e)}
                        onChange={handleSearch}
                        autoComplete="off"
                      />
                      <BiX
                        className="nav-search-icon322"
                        // onClick={onClickSearch}
                        onClick={onCloseSearch}
                        color="#fff"
                      />
                    </span>
                  </div>
                )}
              </li>
              <li className="nav-li d-flex align-items-center">
                <Link
                  to={
                    isAuth == false
                      ? `/sample-properties`
                      : subscription_details == "Your subscription is expired."
                      ? `/sample-properties`
                      : `/properties`
                  }
                  onClick={() => {
                    if (setType) {
                      setPage(1);
                      setType("");
                      // setRoom("")
                    }
                  }}
                >
                  12{" "}
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_latest").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_latest")[0][
                          "value"
                        ] || "lbl_latest"
                      : "lbl_latest"
                    : "lbl_latest"}
                </Link>
              </li>
              <li className="nav-li d-flex align-items-center">
                <Link
                  to={
                    isAuth == false
                      ? `/sample-properties`
                      : subscription_details == "Your subscription is expired."
                      ? `/sample-properties`
                      : isCardView
                      ? "/properties/room/1"
                      : "/properties-list"
                  }
                  onClick={() => {
                    if (setType) {
                      setPage(1);
                      setType("1");
                      // setRoom("")
                    }
                  }}
                >
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_room_studio")
                        .length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_room_studio")[0][
                          "value"
                        ] || "lbl_room_studio"
                      : "lbl_room_studio"
                    : "lbl_room_studio"}
                </Link>
              </li>
              <li className="nav-li d-flex align-items-center">
                <Link
                  to={
                    isAuth == false
                      ? `/sample-properties`
                      : subscription_details == "Your subscription is expired."
                      ? `/sample-properties`
                      : isCardView
                      ? "/properties/room/2"
                      : "/properties-list"
                  }
                  onClick={() => {
                    if (setType) {
                      setPage(1);
                      setType("2");
                      // setRoom("")
                    }
                  }}
                >
                  2{" "}
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_rooms").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_rooms")[0][
                          "value"
                        ] || "lbl_rooms"
                      : "lbl_rooms"
                    : "lbl_rooms"}
                </Link>
              </li>
              <li className="nav-li d-flex align-items-center">
                <Link
                  to={
                    isAuth == false
                      ? `/sample-properties`
                      : subscription_details == "Your subscription is expired."
                      ? `/sample-properties`
                      : isCardView
                      ? "/properties/room/3"
                      : "/properties-list"
                  }
                  onClick={() => {
                    if (setType) {
                      setPage(1);
                      setType("3");
                      // setRoom("")
                    }
                  }}
                >
                  3{" "}
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_rooms").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_rooms")[0][
                          "value"
                        ] || "lbl_rooms"
                      : "lbl_rooms"
                    : "lbl_rooms"}
                </Link>
              </li>
              <li className="nav-li d-flex align-items-center">
                <Link
                  to={
                    isAuth == false
                      ? `/sample-properties`
                      : subscription_details == "Your subscription is expired."
                      ? `/sample-properties`
                      : isCardView
                      ? "/properties/room/4"
                      : "/properties-list"
                  }
                  onClick={() => {
                    if (setType) {
                      setPage(1);
                      setType("4");
                      // setRoom("")
                    }
                  }}
                >
                  4{" "}
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_rooms").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_rooms")[0][
                          "value"
                        ] || "lbl_rooms"
                      : "lbl_rooms"
                    : "lbl_rooms"}
                </Link>
              </li>
              <li className="nav-li d-flex align-items-center">
                <Link
                  to={
                    isAuth == false
                      ? `/sample-properties`
                      : subscription_details == "Your subscription is expired."
                      ? `/sample-properties`
                      : isCardView
                      ? "/properties/room/5"
                      : "/properties-list"
                  }
                  onClick={() => {
                    if (setType) {
                      setPage(1);
                      setType("5");
                      // setRoom("")
                    }
                  }}
                >
                  5+{" "}
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_rooms").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_rooms")[0][
                          "value"
                        ] || "lbl_rooms"
                      : "lbl_rooms"
                    : "lbl_rooms"}
                </Link>
              </li>
              <li className="nav-li d-flex align-items-center">
                <Link
                  to={
                    isAuth == false
                      ? `/sample-properties`
                      : subscription_details == "Your subscription is expired."
                      ? `/sample-properties`
                      : isCardView
                      ? "/properties/type/detachedHouse"
                      : "/properties-list"
                  }
                  onClick={() => {
                    if (setType) {
                      setPage(1);
                      setType("6");
                      // setRoom("")
                    }
                  }}
                >
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")
                        .length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_detached_house"
                        )[0]["value"] || "lbl_detached_house"
                      : "lbl_detached_house"
                    : "lbl_detached_house"}
                </Link>
              </li>
              <li className="nav-li d-flex align-items-center">
                <Link
                  to={
                    isAuth == false
                      ? `/sample-properties`
                      : subscription_details == "Your subscription is expired."
                      ? `/sample-properties`
                      : isCardView
                      ? "/properties/type/townhouseTwin"
                      : "/properties-list"
                  }
                  onClick={() => {
                    if (setType) {
                      setPage(1);
                      setType("7");
                      // setRoom("")
                    }
                  }}
                >
                  {frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")
                        .length > 0
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_townhouse_twin"
                        )[0]["value"] || "lbl_townhouse_twin"
                      : "lbl_townhouse_twin"
                    : "lbl_townhouse_twin"}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

NavbarSection.defaultProps = {
  isCardView: true,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  subscriptions: state.subscription,
  label: state.language,
});

export default connect(mapStateToProps, { runningSubscription })(NavbarSection);
